import { kstShort } from "./view";

// 알림 종(계약 §4-2): 안 읽은 챗봇 문의와 「가맹점주 새 글」을 따로 센다.
const Row = ({ q, onOpen }) => (
    <a href={`#inquiry-${q.id}`} onClick={(e) => { e.preventDefault(); onOpen(q.id); }}>
        <b>{q.store?.name}</b> · {q.subcategory?.label}<small>{q.request_content} · {kstShort(q.created_at)}</small>
    </a>
);

export default function NotifPanel({ items, posts = [], onOpen }) {
    return (
        <div className="notif on">
            <h4>안 읽은 문의 {items.length}건</h4>
            {items.length === 0 ? <div className="empty">새 문의가 없습니다</div> : items.map((q) => <Row key={q.id} q={q} onOpen={onOpen} />)}
            <h4 style={{ marginTop: 8 }}>가맹점주 새 글 {posts.length}건</h4>
            {posts.length === 0 ? <div className="empty">가맹점주가 덧붙인 글이 없습니다</div> : posts.map((q) => <Row key={`p${q.id}`} q={q} onOpen={onOpen} />)}
        </div>
    );
}
